import { Object3D } from 'three'
import GameObject from './GameObject'

export enum GAME_OBJECTS {
  OBJECT = 'OBJECT',
  INTERACTIVE = 'INTERACTIVE',
  OBSTACLE = 'OBSTACLE',
  TREASURE = 'TREASURE',
  CHARACTER = 'CHARACTER',
  MINION = 'MINION',
  TILE = 'TILE',
  CANDY = 'CANDY',
  SPELL = 'SPELL',
}

export type GameObject3D = Object3D & { __gameObject: GameObject }
